export default __webpack_public_path__ + "static/media/carouselImage3.d28b5df0.jpg";